export default "__VITE_ASSET__Cr5hLANo__"